import { render, staticRenderFns } from "./SetupAuthenticator.vue?vue&type=template&id=4dcd2adb&"
import script from "./SetupAuthenticator.vue?vue&type=script&lang=js&"
export * from "./SetupAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports